import {
  getTpaStreamAnalyticsFlowOutcome,
  setTpaStreamAnalyticsFlowOutcome,
  shouldEmitTpaStreamConnectionAbandoned,
} from 'utils/tpaStreamAnalyticsFlow';

import { postTpaStreamAnalyticsEvent } from 'services/api/tpaStreamAnalyticsApi';

function fireAnalyticsEvent(eventType: Parameters<typeof postTpaStreamAnalyticsEvent>[0]): void {
  void postTpaStreamAnalyticsEvent(eventType);
}

function isTerminalTpaStreamAnalyticsOutcome(): boolean {
  const outcome = getTpaStreamAnalyticsFlowOutcome();
  return outcome === 'completed' || outcome === 'failed' || outcome === 'abandoned';
}

/** Beginning of the TPA Stream connection (after session bootstrap succeeds). */
export function emitTpaStreamOauthInitiated(): void {
  setTpaStreamAnalyticsFlowOutcome('started');
  fireAnalyticsEvent('oauth_initiated');
}

/** Insurance provider correctly connected — terminal success. */
export function emitTpaStreamOauthCompleted(): void {
  if (isTerminalTpaStreamAnalyticsOutcome()) {
    return;
  }

  setTpaStreamAnalyticsFlowOutcome('completed');
  fireAnalyticsEvent('oauth_completed');
}

/** Full TPA Stream connection completed successfully. */
export function emitTpaStreamAccountConnectionCompleted(): void {
  if (getTpaStreamAnalyticsFlowOutcome() !== 'completed') {
    return;
  }

  fireAnalyticsEvent('account_connection_completed');
}

/** Connection attempt failed — terminal failure. */
export function emitTpaStreamOauthFailed(): void {
  if (isTerminalTpaStreamAnalyticsOutcome()) {
    return;
  }

  setTpaStreamAnalyticsFlowOutcome('failed');
  fireAnalyticsEvent('oauth_failed');
}

/** Successful connect: oauth_completed + account_connection_completed (once each). */
export function emitTpaStreamConnectionSucceeded(): void {
  emitTpaStreamOauthCompleted();
  emitTpaStreamAccountConnectionCompleted();
}

/**
 * Best-effort: user started connect but left without success or failure.
 * No-op when flow was never started or already reached a terminal outcome.
 */
export function emitTpaStreamAccountConnectionAbandoned(): void {
  if (!shouldEmitTpaStreamConnectionAbandoned()) {
    return;
  }

  setTpaStreamAnalyticsFlowOutcome('abandoned');
  fireAnalyticsEvent('account_connection_abandoned');
}
